/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Lead Opportunity

1 = Lead Activity

2 = Jobs (Job Info)

3 = Client Contacts

4 = Warranty

5 = Subs/Vendors

6 = To-Do's

7 = PO Payments

8 = Change Orders

9 = Invoices

10 = Internal Users

11 = Daily Logs

12 = RFI

13 = Selections

14 = Purchase Orders

15 = Tasks


 */
export type CustomFieldAssociatedType =
  (typeof CustomFieldAssociatedType)[keyof typeof CustomFieldAssociatedType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomFieldAssociatedType = {
  Lead: 0,
  LeadActivity: 1,
  JobsJobInfo: 2,
  Contacts: 3,
  Warranty: 4,
  Subs: 5,
  ToDos: 6,
  PurchaseOrderPayments: 7,
  ChangeOrders: 8,
  OwnerPayments: 9,
  InternalUsers: 10,
  DailyLogs: 11,
  RFIs: 12,
  Selections: 13,
  PurchaseOrders: 14,
  Tasks: 15,
} as const;
